module.exports = __webpack_public_path__ + "static/media/sopraSteriaLogo.52b57861.png";